import EventHandler from './dom/event-handler';
import SelectorEngine from './dom/selector-engine';

class Effects {
    constructor () {
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.remove('ome-appear-invisible');
                }
            })
        }, {
            threshold: 1
        });

        /** @type {HTMLElement[]} */
        this.appearElems = SelectorEngine.find('.ome-headerlayout-1');

        for (const elem of this.appearElems) {
            const bounding = elem.getBoundingClientRect();
            if ( !(bounding.top >= 0 && bounding.bottom <= document.documentElement.clientHeight) ) {
                this.initElem(elem);
            }
        }
    }

    /** @param {HTMLElement} elem */
    initElem(elem) {
        elem.classList.add('ome-appear-invisible', 'ome-appear-transition');
        this.observer.observe(elem);
    }
}

if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    EventHandler.one(document, 'DOMContentLoaded', () => {
        new Effects();
    });
}

export default Effects;
